import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { useForm, FormProvider } from "react-hook-form";
import { useApp } from "../../context/AppState";
import {
  getStaticCartDrawerSections,
  getStaticCartDrawerSteps,
  STATIC_CART_SECTION_INDEX,
} from "../../constants/custom-cart-drawer-template";
import { useCartDrawerUpsellDiscountSync } from "../../utils/cart-drawer-upsell-discount-sync";
import CartDrawerUpsellStrip from "./CartDrawerUpsellStrip";

/**
 * Upsell-only strip for theme cart inject mode (#weupsell-cart-drwer-upsell).
 */
export default function RenderThemeCartUpsellSlot({
  popupData,
  isMobile = false,
}) {
  const { cartData, setCartData } = useApp();
  const methods = useForm({ defaultValues: {}, mode: "onSubmit" });

  const activeStep = useMemo(
    () => getStaticCartDrawerSteps(popupData).drawerStepIndex ?? 0,
    [popupData]
  );

  const sections = useMemo(
    () => getStaticCartDrawerSections(popupData, activeStep),
    [popupData, activeStep]
  );

  const headingSection = sections[STATIC_CART_SECTION_INDEX.UPSELL_HEADING];
  const productSection = sections[STATIC_CART_SECTION_INDEX.UPSELL_PRODUCT];

  useCartDrawerUpsellDiscountSync({
    popup: popupData,
    cart: cartData,
    enabled: true,
    onCartUpdated: setCartData,
  });

  return (
    <FormProvider {...methods}>
      <div
        className="weupsell-theme-cart-upsell-slot"
        data-weupsell-surface="theme-cart-upsell"
        style={{ overflow: "visible", width: "100%", boxSizing: "border-box" }}
      >
        <CartDrawerUpsellStrip
          popupData={popupData}
          headingSection={headingSection}
          productSection={productSection}
          activeStep={activeStep}
          isPreviewMode={false}
          isMobile={isMobile}
          surface="theme-cart-upsell"
        />
      </div>
    </FormProvider>
  );
}

RenderThemeCartUpsellSlot.propTypes = {
  popupData: PropTypes.object.isRequired,
  isMobile: PropTypes.bool,
};
